module.exports = __webpack_public_path__ + "img/7-1_05.9f93719e.jpg";